
import { useMemo } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import { useEffect, useState } from 'react';
import { GetCostDetails } from '../../api/aditionalCostsSystem';
import { useLoading } from '../LoadingContext';
import { format, parseISO } from 'date-fns';
import Table from '../../components/Table';
import { pl } from 'date-fns/locale';
export default function CostDetailsDialog({ open, onClose, handleSave, details, users=[], setLoading }) {

  const { setLoading: setGlobalLoading } = useLoading();
const [costDetails, setCostDetails] = useState([]);
  const [loading, setLoadingo] = useState(false); 

    useEffect(() => {
   setGlobalLoading(true);    
        const idKosztu = details?.id;

        const loadData = async () => {
    const dane = await GetCostDetails(details.id);

   
    const mapped = dane.map(item => ({
      ...item,
      us_name:
        users.find(user => user.id === item.fv_whoPay)?.us_name || 'BRAK'
    }));

    setCostDetails(mapped);
   // console.log('ID kosztu:', details.id);
  };
  
  loadData();
   setGlobalLoading(false);
    }, [details]);
  const columns = useMemo(() => [
   
    {
      field: 'title',
      headerName: 'Nazwa',
      renderCell: (params) => {
        const row = params.row;
     
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
            {row.fv_name}
            </span>
          </div>
        );
      }
    },
     {
      field: 'number',
      headerName: 'Numer faktury',
      renderCell: (params) => {
        const row = params.row;
     
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
            {row.fv_number}
            </span>
          </div>
        );
      }
    },
    
    {
      field: 'date',
      headerName: 'Data faktury',
      renderCell: (params) => {
        const row = params.row;
        let date = row.fv_date ? format(parseISO(String(row.fv_date)), 'yyyy-MM-dd', { locale: pl }) : "-";
        return <span className="font-medium text-gray-900">{date}</span>;
      }
    },
    {
      field: 'Kwota',
      headerName: 'Kwota',
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 rounded text-xs font-normal text-gray-900">
              {row.fv_value}
            </span>
          </div>
        );
      }
    },
    
    {
      field: 'paydBy',
      headerName: 'Zapłacił',
      renderCell: (params) => <span className="font-medium text-gray-900">{params.row.us_name}</span>
    },
   
    {
        field: 'actions', headerName: 'Akcje',width:50, sortable: false, renderCell: (params) => (
          <div className="flex gap-2">
        </div>
        
        )
      }
  ], []);


    return (
       <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
          >
            <DialogTitle>Szczegóły rozliczenia</DialogTitle>
            <DialogContent className="overflow-y-auto max-h-[70vh]">
              <div className="overflow-x-auto mt-2">
                 <div className="flex items-center gap-2">
                  <p className="text-xs md:text-sm text-gray-500">
                    Szczegółowe dane dotyczące rozliczenia faktury
                  </p> <p className="text-xs md:text-sm text-gray-500 font-bold">
                    {details?.fvnumber}
                  </p>
                </div>
                <div className="mb-4 flex items-center gap-2">
                
                  <p className="text-xs md:text-sm text-gray-500">
                    Faktura opłacona przez
                  </p> <p className="text-xs md:text-sm text-gray-500 font-bold">
                    {details?.us_name}
                  </p>
                </div>


{costDetails && costDetails.length > 0 ? (

  
<div className="flex flex-col gap-2">
   <div className="rounded-sm overflow-hidden">
    <Table columns={columns} data={costDetails} loading={loading} />
    </div>
</div>


):(<div className="flex items-center justify-center mt-4">
  <div className="text-center">
    <p className="text-gray-400 text-sm sm:text-lg font-semibold mb-2">
       Brak danych do wyświetlenia
    </p>
   
  </div>
</div>)}


             
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                size="medium"
                variant="outlined"
                onClick={onClose}
              >
                Anuluj
              </Button>
              <Button
                size="medium"
                variant="contained"
                color="success"
                onClick={handleSave}
              >
                Zapisz
              </Button>
            </DialogActions>
          </Dialog>
    );
}